<template>
  <!-- 线下考试结果 -->
  <div class="index-container">
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 在线考试 > 线下考试
        <span>> 考试结果</span>
      </div>
      <div class="module-box">
        <div class="test-name">
          2021注册照护士执业资格考试
          <span>线下</span>
        </div>
        <div class="test-detail">
          考试时间：
          <span>2021.12.19 14:21:32</span>
        </div>
      </div>
      <div class="table-content">
        <div class="table-title-box">
          <div class="title-list"></div>
          <div class="title-list">外在表现</div>
          <div class="title-list">课堂表现</div>
          <div class="title-list">考试表现</div>
          <div class="title-list">考勤情况</div>
          <div class="title-list">总分</div>
        </div>
        <div class="info-box">
          <div>姓名</div>
          <div>个人品质</div>
          <div>
            课堂纪律
            <span>（10%）</span>
          </div>
          <div>
            行为举止
            <span>（10%）</span>
          </div>
          <div>
            理论课
            <span>（15%）</span>
          </div>
          <div>
            实操课
            <span>（15%）</span>
          </div>
          <div>
            理论课
            <span>（15%）</span>
          </div>
          <div>
            实操课
            <span>（15%）</span>
          </div>
          <div>10%</div>
          <div>100%</div>
        </div>
        <div class="score-box">
          <div>马冬梅</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
          <div>80</div>
        </div>
      </div>
      <div class="video-box">
        <videoPlayer :videoSrc="videoUrl"></videoPlayer>
      </div>
    </div>
  </div>
</template>
<script>
import videoPlayer from '../components/videoPlayer.vue';

export default {
  name: 'resultOffline',
  components: {
    videoPlayer
  },
  data() {
    return {
      videoUrl: ''
    };
  },
  
  mounted() {
    scrollTo(0, 0);
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50PX 0 150PX;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 40PX;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.module-box {
  padding: 40PX 42PX 32PX;
  margin-bottom: 30PX;
  background-color: #ffffff;
  .test-name {
    display: flex;
    align-items: center;
    padding-bottom: 20PX;
    font-size: 26PX;
    color: #333333;
    font-weight: 600;
    span {
      padding: 2PX 5PX;
      margin-left: 8PX;
      font-size: 14PX;
      color: #ffffff;
      background-color: #ff7b1f;
      border-radius: 5PX;
    }
  }
  .test-detail {
    font-size: 16PX;
    color: #777777;
    span {
      color: #333333;
    }
  }
}
.table-content {
  margin-bottom: 34PX;
  background-color: #ffffff;
  border: 1PX solid #cccbcb;
}
.table-title-box {
  display: flex;
  background-color: #e4e4e4;
  border-bottom: 1PX solid #cccbcb;

  .title-list {
    width: 10%;
    padding: 22PX 0;
    font-size: 16PX;
    color: #666666;
    text-align: center;
    border-right: 1PX solid #cccbcb;
    &:nth-child(2) {
      width: 30%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 20%;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.info-box {
  display: flex;
  background-color: #f5f5f5;
  border-bottom: 1PX solid #cccbcb;
  > div {
    width: 10%;
    padding: 12PX 0;
    font-size: 16PX;
    color: #666666;
    text-align: center;
    border-right: 1PX solid #cccbcb;
    &:last-child {
      line-height: 40PX;
      border-right: none;
    }
    &:first-child,
    &:nth-child(2),
    &:nth-child(9) {
      line-height: 40PX;
    }
  }
  span {
    display: block;
  }
}
.score-box {
  display: flex;
  > div {
    width: 10%;
    padding: 22PX 0;
    font-size: 16PX;
    text-align: center;
    border-right: 1PX solid #cccbcb;
    &:last-child {
      border-right: none;
    }
  }
}
.video-box {
  width: 26%;
  height: 210PX;
}
</style>


// WEBPACK FOOTER //
// src/views/resultOffline.vue